import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Calendar } from "lucide-react";
import { InvoiceGroupedList } from "@/components/invoices/InvoiceGroupedList";

interface Invoice {
  id: string;
  payment_amount: number;
  payment_due_date: string;
  supplier_name: string;
  supplier_email: string;
  status: string;
  discount_amount: number | null;
  discounted_payment_amount: number | null;
  created_at: string;
}

interface PaymentRunModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invoices: Invoice[];
}

export function PaymentRunModal({ open, onOpenChange, invoices }: PaymentRunModalProps) {
  const achInvoices = invoices.filter(
    (inv) => inv.status === "early_payment_scheduled" || inv.status === "early_payment"
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-warning" />
            Due in Next Payment Run
          </DialogTitle>
          <DialogDescription>{achInvoices.length} invoice(s) ready for payment</DialogDescription>
        </DialogHeader>
        <InvoiceGroupedList
          invoices={achInvoices}
          emptyMessage="No invoices ready for payment"
          showStatus={false}
        />
      </DialogContent>
    </Dialog>
  );
}
